import React from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { receiptModalState, ReceiptModalType } from "../../recoil/receiptModal";

type ReceiptOrderType = {
  approvalNumber: string;
  card: string;
  cardNm: string;
  cardPurchaseName: string;
  confirmDateCancel: string;
  confirmDatePay: string;
  createDate: string;
  dicountAmount: string;
  formattedCreateDate: string;
  license_number: string;
  merchant_no: string;
  order_phone: string;
  pickup_type: number;
  stampCouponDiscount: string;
  state_code: string;
  state_id: number;
  storeAddress: string;
  storeNm: string;
  storeOwner: string;
  storePhone: string;
  totalAmount: string;
  totalAmountOrg: string;
  updateDate: string;
  userPoint: string;
  validCardYn: string | null;
};
type ReceiptProductType = {
  amount_tax_excl: string;
  amount_tax_incl: string;
  base_price: string;
  itemNm: string;
  options: ReceiptOptionType[];
  order_detail_id: number;
  order_prd_key: string;
  prd_price: string;
  quantity: number;
};
type ReceiptOptionType = {
  name: string;
  price: string;
  product_option_id: number;
  quantity: number;
};

const RecoilReceiptModal: React.FC = () => {
  const [modalStates, setModalStates] =
    useRecoilState<ReceiptModalType>(receiptModalState);

  const closeModal = () => {
    setModalStates((prev) => ({
      ...prev,
      visibleConfirm: false,
      optionData: [],
    }));
  };

  return (
    <Style>
      {modalStates.visibleConfirm && (
        <div className="modalWrap">
          <div className="modal">
            <h2 className="header">
              {modalStates.modalData.sPurchaseDetailData.storeNm}
            </h2>
            <img
              className="closeIcon"
              onClick={closeModal}
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="close"
            />
            <div className="receiptWrap">
              {/* <h3>{modalStates.modalData.sPurchaseDetailData.createDate}</h3>
              <h3>{modalStates.modalData.sPurchaseDetailData.storeNm}</h3>
              <h3>{modalStates.modalData.sPurchaseDetailData.storeAddress}</h3>
              <h3>
                대표: {modalStates.modalData.sPurchaseDetailData.storeOwner}
              </h3>
              <h3>
                Tel: {modalStates.modalData.sPurchaseDetailData.storePhone}
              </h3>
              <div className="croessLine" /> */}
              {/* {modalStates.modalData.sPurchaseDetailData.pickup_type &&
              modalStates.modalData.sPurchaseDetailData.pickup_type === 2 ? (
                <h2>
                  매장에서 픽업{" "}
                  {modalStates.modalData.sPurchaseDetailData.order_phone}
                </h2>
              ) : (
                <h2>
                  {modalStates.modalData.sPurchaseDetailData.license_number}
                </h2>
              )} */}
              {/* <div className="productListWrap">
                <h3 className="name">품목</h3>
                <h3 className="etc">수량</h3>
                <h3 className="etc">금액</h3>
              </div>
              <div className="croessLine" /> */}
              {modalStates.modalData.aPurchaseDataList.map(
                (item: ReceiptProductType, index: number) => {
                  return (
                    <div className="productListWrap" key={index}>
                      <div className="productWrap">
                        <h2 className="name">{item.itemNm}</h2>
                        <h2 className="etc">{item.quantity}</h2>
                        <h2 className="etc price">{item.base_price}원</h2>
                      </div>
                      {item.options.map(
                        (option: ReceiptOptionType, optionIdx: number) => {
                          return (
                            <div key={optionIdx} className="productWrap option">
                              <h2 className="name">
                                <span>&#8627;</span> {option.name}
                              </h2>
                              <h2 className="etc">{option.quantity}</h2>
                              <h2 className="etc price">{option.price}원</h2>
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
              <div className="croessLine" />
              <div className="totalWrap">
                <h2 className="title">총금액</h2>
                <h2 className="content">
                  {modalStates.modalData.sPurchaseDetailData.totalAmountOrg}원
                </h2>
              </div>
              {modalStates.modalData.sPurchaseDetailData.userPoint &&
                modalStates.modalData.sPurchaseDetailData.userPoint !== "" && (
                  <>
                    <div className="totalWrap">
                      <h2 className="title">포인트</h2>
                      <h2 className="content">
                        {modalStates.modalData.sPurchaseDetailData.userPoint}원
                      </h2>
                    </div>
                  </>
                )}
              {modalStates.modalData.couponList &&
                modalStates.modalData.couponList !== "" && (
                  <>
                    <div className="totalWrap">
                      <h2 className="title">쿠폰</h2>
                      <h2 className="content">
                        {modalStates.modalData.couponList}원
                      </h2>
                    </div>
                  </>
                )}
              {modalStates.modalData.sPurchaseDetailData.stampCouponDiscount &&
                modalStates.modalData.sPurchaseDetailData
                  .stampCouponDiscount !== "" && (
                  <>
                    <div className="totalWrap">
                      <h2 className="title">선불권</h2>
                      <h2 className="content">
                        {
                          modalStates.modalData.sPurchaseDetailData
                            .stampCouponDiscount
                        }
                        원
                      </h2>
                    </div>
                  </>
                )}
              {modalStates.modalData.sPurchaseDetailData.couponCodeDiscount &&
                modalStates.modalData.sPurchaseDetailData.couponCodeDiscount !==
                  "" && (
                  <>
                    <div className="totalWrap">
                      <h2 className="title">쿠폰 코드</h2>
                      <h2 className="content">
                        {
                          modalStates.modalData.sPurchaseDetailData
                            .couponCodeDiscount
                        }
                        원
                      </h2>
                    </div>
                  </>
                )}
              <div className="croessLine" />
              <div className="totalWrap">
                <h1 className="title">결제금액</h1>
                <h1 className="content">
                  {modalStates.modalData.sPurchaseDetailData.totalAmount}원
                </h1>
              </div>
              <div className="croessLine" />
              {/* <div className="totalWrap">
                <h2>포장/매장</h2>
                <h2>
                {modalStates.modalData.sPurchaseDetailData.pickup_type === 1 ? '포장' : '매장'}
                </h2>
              </div> */}
              <div className="totalWrap">
                <h2 className="title">카드번호</h2>
                <h2 className="content">
                  ****-****-****-
                  {modalStates.modalData.sPurchaseDetailData.validCardYn}
                </h2>
              </div>
              <div className="totalWrap">
                <h2 className="title">승인번호</h2>
                <h2 className="content">
                  {modalStates.modalData.sPurchaseDetailData.approvalNumber}
                </h2>
              </div>
              <div className="totalWrap">
                <h2 className="title">거래일시</h2>
                <h2 className="content">
                  {modalStates.modalData.sPurchaseDetailData.confirmDatePay}
                </h2>
              </div>
              <div className="totalWrap">
                <h2 className="title">매장주소</h2>
                <h2 className="content">
                  {modalStates.modalData.sPurchaseDetailData.storeAddress}
                </h2>
              </div>
              {/* <h3>
                승인번호 :{" "}
                {modalStates.modalData.sPurchaseDetailData.approvalNumber}
              </h3>
              <h3>
                매입 :{" "}
                {modalStates.modalData.sPurchaseDetailData.cardPurchaseName}
              </h3>
              <h3>
                가맹 : {modalStates.modalData.sPurchaseDetailData.merchant_no}
              </h3> */}
              <div className="croessLine" />
              <h3 className="comment">
                결제취소/재결제의 경우 반드시 해당 매장에서 매장직원을 통하여
                직접 진행하셔야 합니다.
              </h3>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default RecoilReceiptModal;

const Style = styled.div`
  .modalWrap {
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.4);
  }
  .modal {
    width: 35vw;
    max-height: 85vh;
    height: 85vh;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    background: #000;
    border: 1px solid #646464;
  }

  .header {
    text-align: center;
    font-size: 28px;
    line-height: 40px;
    padding: 0 60px;
    border-bottom: 1px solid #737373;
    padding-bottom: 20px;
  }
  .closeIcon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  .receiptWrap {
    width: 100%;
    height: 100%;
    padding: 24px 36px;
    overflow-y: auto;
    h2,
    h3,
    h4 {
      margin-top: 4px;
      font-weight: 500;
    }
    h3.comment {
      padding-top: 28px;
      color: #797979;
    }

    .productListWrap {
      padding-top: 16px;
      .productWrap {
        display: flex;
        justify-content: space-between;
        word-break: keep-all;
        padding-bottom: 6px;
        span {
          font-size: 12px;
        }

        .name {
          width: 50%;
          text-align: left;
        }
        .etc {
          width: 25%;
          text-align: center;
        }
        .etc.price {
          text-align: right;
        }
      }
      .productWrap.option {
        padding-top: 0px;
      }
    }
    .totalWrap {
      display: flex;
      justify-content: space-between;
      padding-top: 16px;
      .title {
        width: 35%;
      }
      .content {
        width: 65%;
        text-align: right;
      }
    }
    .productListWrap:nth-child(1),
    .totalWrap:nth-child(1) {
      padding: 0;
    }
  }
  .croessLine {
    width: 100%;
    height: 1px;
    margin-top: 16px;
    background: repeating-linear-gradient(
      90deg,
      #737373,
      #737373 10px,
      transparent 10px,
      transparent 20px
    );
  }
  @media (max-width: 1400px) {
    .modal {
      width: 80vw;
    }
  }
`;
